import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-23/task-01";

const task: Slide = {
  title: "Which of the following four circuits is a first-order high-pass filter?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
